'use client';

import { Box, Button, buttonClasses, Link, Pagination, Stack, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import IconifyIcon from '../../../../comDash/src/ui/components/base/IconifyIcon';

const CustomTablePaginationAction = ({
  page,
  rowsPerPage,
  count,
  onPageChange,
  onShowAllClick,
  onNextClick,
  onPrevClick,
  showAllHref,
  showFullPagination,
}) => {
  const theme = useTheme();
  const upSm = useMediaQuery(theme.breakpoints.up('sm'));

  return (
    <Stack
      sx={{
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1,
        ml: { sm: 1 },
      }}
    >
      <Link
        variant="caption"
        href={showAllHref || "#!"}
        onClick={(e) => {
          e.preventDefault();
          if(onShowAllClick) onShowAllClick();
        }}
        sx={{ fontWeight: 700, flexShrink: 0, mt: { sm: 0.5 } }}
      >
        {rowsPerPage === count ? 'View less' : 'Show all'}
      </Link>

      {showFullPagination ? (
        <Pagination
          color="primary"
          variant="solid"
          showFirstButton={upSm}
          showLastButton={upSm}
          count={Math.ceil(count / Math.max(1, rowsPerPage))}
          page={page + 1}
          onChange={(event, newPage) => onPageChange(event, newPage - 1)}
          sx={{ flexShrink: 0 }}
        />
      ) : (
        <>
          <Button
            variant="text"
            color="primary"
            size="small"
            startIcon={
              <IconifyIcon
                flipOnRTL
                icon="material-symbols:chevron-left-rounded"
                sx={{ fontSize: '18px !important' }}
              />
            }
            disabled={page === 0}
            onClick={onPrevClick}
            sx={{
              ml: 'auto',
              minWidth: 'auto',
              [`& .${buttonClasses.startIcon}`]: {
                mr: { xs: 0, sm: 0.5 },
              },
            }}
          >
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
              Previous
            </Box>
          </Button>
          <Button
            disabled={(page + 1) * rowsPerPage >= count}
            onClick={onNextClick}
            variant="text"
            color="primary"
            size="small"
            endIcon={
              <IconifyIcon
                flipOnRTL
                icon="material-symbols:chevron-right-rounded"
                sx={{ fontSize: '18px !important' }}
              />
            }
            sx={{
              minWidth: 'auto',
              [`& .${buttonClasses.endIcon}`]: {
                ml: { xs: 0, sm: 0.5 },
              },
            }}
          >
            <Box component="span" sx={{ display: { xs: 'none', sm: 'inline-block' } }}>
              Next
            </Box>
          </Button>
        </>
      )}
    </Stack>
  );
};

export default CustomTablePaginationAction;